module.exports = __webpack_public_path__ + "static/media/warning-alarm.3ea80bd5.wav";